import EventBus from '../wirebox/event-bus'
import jQuery from 'jquery'

class ConfirmationModule {
    
    /**
     * Construct module
     * @param container
    */
    constructor(container) {
        
        /**
         * Container jQuery object
         * @type {object}
        */
        this.container = container
        
        /**
         * Content jQuery object
         * @type {array}
        */
        this.content = jQuery('#confirmation-content')
        
        /**
         * Yes button jQuery object
         * @type {array}
        */
        this.yesBtn = jQuery('#confirmation-yes')
        
        /**
         * Callback
         * @type {function}
        */
        this.callback = null
        
        /**
         * Event element jQuery object
         * @type {array}
        */
        this.element = null
        
        this.bindEvents()
        
    }
    
    /**
     * Create Confirmation
     * @params params
     */
    createConfirmation(params) {
        this.callback = params.callback
        this.content.html(params.content)
        this.container.modal('show')
    }
    
    /**
     * Yes button has been clicked
    */
    yesClicked() {
        this.container.modal('hide')
        this.callback()
    }
    
    /**
     * A confirmation hyperlink has been clicked
     * @param event
    */
    /*confirmationLinkClicked(event) {
        
        event.preventDefault()
        this.element = jQuery(event.target)
        let content = this.element.data('confirmation')
        
        this.createConfirmation({
            callback: () => {
                window.location = this.element.attr('href')
            },
            content: content ? content : 'Are you sure?'
        })
        
    }*/
    
    /**
     * A confirmation form has been submitted
     * @param event
    */
    confirmationFormSubmit(event, param) {
        
        event.preventDefault()
        this.element = jQuery(event.target)
        let content = this.element.data('confirmation')
        
        this.createConfirmation({
            callback: () => {
                this.element.removeClass('.confirmation-form')
                this.element[0].submit()
                this.element.addClass('.confirmation-form')
                EventBus.publish('prepare-form-submit', this.element)
            },
            content: content ? content : 'Are you sure?'
        })
        
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Show confirmation
        EventBus.subscribe('confirmation', this.createConfirmation.bind(this))
        
        //Yes button click
        this.yesBtn.click(this.yesClicked.bind(this))
        
        //Hyperlink button click
        //jQuery(document).on('click', '.confirmation-link', this.confirmationLinkClicked.bind(this))
        
        //Form submit
        jQuery(document).on('submit', '.confirmation-form', this.confirmationFormSubmit.bind(this))
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    let container = jQuery('#confirmation-modal')
    
    if (container.length > 0) {
        new ConfirmationModule(container)
    }
    
})

export default ConfirmationModule